module.exports = __webpack_public_path__ + "home.png";